import { SchemaIO, SchemaScheduleService } from '@frontend/schema';
import { useScopedQuery } from '@frontend/scope';

export const queryKeys = {
  base: 'email-composer',
  onlineScheduleLink: () => [queryKeys.base, 'online-scheduling-link'],
};

type SchemaGetOnlineSchedulingLink = SchemaIO<(typeof SchemaScheduleService)['GetOnlineSchedulingLink']>;
export const useGetOnlineSchedulingLink = (request: SchemaGetOnlineSchedulingLink['input']) =>
  useScopedQuery({
    refetchOnMount: false,
    queryKey: queryKeys.onlineScheduleLink(),
    queryFn: () => SchemaScheduleService.GetOnlineSchedulingLink(request),
    enabled: !!request.locationId,
    select: (response) => response.url,
  });
